import "flatpickr/dist/flatpickr.min.css";
import FlatpickrControl from './flatpickr-control';


// flatpickr
[].slice.call(document.querySelectorAll<HTMLElement>("[data-flatpickr], [data-flatpickr-time], [data-flatpickr-range], [data-flatpickr-range-with]")).forEach((element: HTMLElement) => {
    // init
    if (!element.hasAttribute("data-flatpickr-manual")) {
        const picker = new FlatpickrControl(element);
        picker.init();
    }
});
export default undefined;